<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6">
                    <h1 class="d-inline-block mb-0">Häufig gestellte Fragen</h1>
                </div>
            </div>
            <h2>Talus Supportline: +41 32 391 90 40</h2>
        </base-header>
        <div class="container-fluid mt--7">
            <div class="row">
                <card header-classes="bg-transparent" class="card-pricing border-0 mb-4">
                    <ul>
                        <li><b>Mein Zwei-Faktor-Authentifizierungs-Code funktioniert nicht.</b></li>
                        <p>Der Zwei-Faktor-Authentifizierungs-Code darf keine Leerzeichen oder Sonderzeichen enthalten
                            und muss eine sechsstellige Nummer sein.
                            <br/>Bei Fragen melden Sie sich bei der Talus Supportline.</p>
                        <li><b>Ich bin nicht RIO Kunde und kann mich nicht anmelden.</b></li>
                        <p>Wenden Sie sich an Ihren IT-Administrator, um Ihr Benutzerprofil importieren zu lassen und
                            die benötigten Rechte zu erhalten.</p>
                        <li><b>Wo finde ich meinen Registrations-Token?</b></li>
                        <p>Ihr Registrations-Token wurde Ihnen via E-Mail zugesendet. Bei Fragen melden Sie sich bei der
                            Talus Supportline.</p>
                        <li><b>Mein Registrations-Token ist abgelaufen.</b></li>
                        <p>Wenn Ihr Registrations-Token abgelaufen ist, wenden Sie sich an die Talus Supportline. Wir
                            stellen Ihnen
                            einen neuen Registrations-Token zur Verfügung.</p>
                    </ul>

                    <div class="flex-column py-4 ml-4">
                        <h2>Anleitungen</h2>
                        <ul class="font-weight-bold">
                            <li>
                                <a href="/docs/TOK Anmeldung via Bestätigungscode.pdf" target="_blank"
                                   download="TOK_Anmeldung_Bestaetigungscode.pdf">myTalus Anmeldung via
                                    Registrations-Token</a>
                            </li>
                            <li>
                                <a href="https://youtu.be/cPU_6V06apw" target="_blank">myTalus Instruktion Inhouse
                                    Kunden</a>
                            </li>
                            <li>
                                <a href="https://youtu.be/JuqAEZ6f5O4" target="_blank">myTalus Instruktion RIO
                                    Kunden</a>
                            </li>
                        </ul>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Help",
    components: {},
    props: {},

}
</script>

<style scoped>

</style>
